<aumico-table-with-form
    [options]="tableOptions"
    [editable]="editable"
    [editableHeaders]="editable"
    [displayedColumns]="displayedColumns"
    [delegate]="this"
    [data]="FreeTableData.rows"
    [additionalHeaders]="additionalHeaders"
    [language]="language"
    [hasTotalRow]="ComponentOptions.totalRow"
    [textTitle]="tableOptions.properties[0].name"
    (formChange)="onFormChange($event)"
    [viewMode]="viewMode"
    [totalRowText]="totalRowTextCell"
    [todoHighlight]="highlightTodos"
    [isReferenced]="addReferencing"
    [isNumbered]="addNumbering"
    [tableNumber]="tableNumber"
    (onAddNumberingClicked)="onAddNumberToggleChange($event)"
    (onAddReferencingClicked)="openReferenceDialog()"
></aumico-table-with-form>
